import {Component, OnInit, ViewChild} from "@angular/core";
import {AppModalComponent} from "../../../shared/modal/modal";
/**
 * Created by nijin on 26/6/17.
 */
@Component({
  selector: 'nuc-schema-warning-popup',
  styles: [`
        span.bold{
          font-weight: 600;
        }
        .modal-title{
          font-weight: 600;
          color: #ca2d2d;
          text-align: center;
        }
    `],
  template: `
         <app-modal #popup>
  <div class="app-modal-header">
    <h4 class="modal-title">Incomplete Configuration!!</h4>
  </div>
  <div class="app-modal-body">
    <p>The <span class="bold">Attributes/Location</span> data has not been configured properly. Please complete the same to proceed to the next step.</p>
  </div>
  <div class="app-modal-footer">
    <div class="btn-group-1 text-center">
      <button class="btn btn-primary" (click)="close()" id="configure">
        Configure
        </button>
    </div>
  </div>
</app-modal>
     
   `
})
export class  SchemaUpdateWarning implements OnInit {
    @ViewChild('popup') warningModal: AppModalComponent;

    ngOnInit(){

    }

    open(){
      this.warningModal.open();
    }

    close(){
      this.warningModal.hide();
    }
}



// WEBPACK FOOTER //
// ./src/app/schema/shared/modal/warning.modal.ts